import React, { Component } from 'react';
import PropTypes from 'prop-types';
import config from '../../config';

export default class EmptyState extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const data = this.props.data;

        return  <div className="dashboard-card">
                    <h3>{data.heading}</h3>
                    <hr />
                    {data.body.header}
                    <img className="img-fluid" src={`${config.s3BucketUrl}/dashboards/img-dashboard-createnow%402x.jpg`}/>
                    <p className="text-center my-2">{data.body.description}</p>
                    <div className="text-center m-4">
                        {data.ctaButtons.map((btn, index) => {
                          const button = <button className={`btn btn-${btn.type === 'primary' ? '' : 'outline-'}primary mb-3 mb-md-0 mr-md-3`}>{btn.label}</button>;
                          if (btn.refresh) {
                            return <a key={index} href={btn.url}>
                              {button}
                            </a>
                          }
                          return <Link key={index} to={btn.url}>
                            {button}
                          </Link>
                        })
                        }
                    </div>
                </div>
    }
}

EmptyState.propTypes = {
  data: PropTypes.shape({
    heading: PropTypes.object.isRequired,
    body: PropTypes.shape({
      header: PropTypes.object,
      description: PropTypes.object
    }).isRequired,
    ctaButtons: PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.string.isRequired,
      label: PropTypes.object.isRequired
    }))
  })
};



// WEBPACK FOOTER //
// ./src/Account/EmptyState.js